const b = (i) => {
  const {
    rules: e,
    shouldUnregister: l,
    control: n,
    name: r,
    defaultValue: a,
    disabled: p,
    error: c,
    label: h,
    formId: o,
    hint: m,
    optional: u,
    hiddenLabel: P,
    ...d
  } = i, t = d.id ?? (o ? `${o}__${r}` : void 0), s = {
    name: r,
    disabled: p,
    required: !!(e != null && e.required)
  };
  return {
    fieldProps: {
      // Props for RHF - UseController
      defaultValue: a,
      // Only passed to UseController, so we don't get any logs from IDS about controlled and uncontrolled state
      rules: e,
      control: n,
      shouldUnregister: l,
      // Field props
      hiddenLabel: P,
      error: c,
      label: h,
      htmlFor: t,
      hint: m,
      optional: u,
      // Shared between element and field
      ...s
    },
    ...s,
    ...d,
    id: t
  };
};
export {
  b as mapFieldProps
};
